import request from '@/utils/request';
import { IOrderParams, IOrderOperationParams } from '@/types/order';
// 所有报修导出订单
export const exportOrderAll = (data:any) =>
  request({
    url: 'OrderAll/export',
    method: 'post',
    data
  });
// 导出订单
export const exportOrder = (data:any) =>
  request({
    url: 'Order/export',
    method: 'post',
    data
  });
// 导出分公司报修单
export const exportBranchOrder = (data:any) =>
  request({
    url: 'Order/exportBranchOrder',
    method: 'post',
    data
  });

export const getAllOrderList = (params: IOrderParams) =>
  request({
    url: 'OrderAll/orderList',
    method: 'get',
    params
  });

export const getAllOrderDetail = (params: any) =>
  request({
    url: 'OrderAll/order',
    method: 'get',
    params
  });

export const getOrderList = (params: IOrderParams) =>
  request({
    url: 'Order/orderList',
    method: 'get',
    params
  });

export const getOrderDetail = (params: any) =>
  request({
    url: 'Order/order',
    method: 'get',
    params
  });
export const getorderDispose = (params: any) =>
  request({
    url: 'Order/orderDispose',
    method: 'get',
    params
  });
export const getProgressList = (params: any) =>
  request({
    url: 'Order/progressList',
    method: 'get',
    params
  });

export const getOrderBBS = (params: any) =>
  request({
    url: 'Order/bbs',
    method: 'get',
    params
  });
export const getBbsOrderList = (params: any) =>
  request({
    url: 'Order/bbsOrderList',
    method: 'get',
    params
  });

export const addOrderBBS = (data: any) =>
  request({
    url: 'Order/bbs',
    method: 'post',
    data
  });

/**
 * 订单完成
 */
export const orderFinish = (data: IOrderOperationParams) =>
  request({
    url: 'Order/orderFinish',
    method: 'PUT',
    data
  });

/**
 * 取消订单
 */
export const orderClose = (data: IOrderOperationParams) =>
  request({
    url: 'Order/orderClose',
    method: 'PUT',
    data
  });

/**
 * 催单
 */
export const orderRemind = (data: IOrderOperationParams) =>
  request({
    url: 'Order/orderRemind',
    method: 'POST',
    data
  });
/**
* 评价获取
*/
export const getEvaluateOrder = (params: any) =>
  request({
    url: 'Order/orderEvaluate',
    method: 'get',
    params
  });
/**
* 评价
*/
export const evaluateOrder = (data: any) =>
  request({
    url: 'Order/orderEvaluate',
    method: 'POST',
    data
  });
export const sendOut = (data: any) =>
  request({
    url: 'Order/sendOut',
    method: 'put',
    data
  });

// 报修单初始化 Order/init

export const getOrderHistory = (params: any) =>
  request({
    url: 'Customer/orderHistory',
    method: 'GET',
    params
  });

export const getOrderInit = (params: any) =>
  request({
    url: 'Order/init',
    method: 'GET',
    params
  });
  // 创建订单
export const createOrder = (data:any) =>
  request({
    url: 'Order/order',
    method: 'post',
    data
  });
// 添加补充进度
export const addedProgress = (data:any) =>
  request({
    url: 'Order/addedProgress',
    method: 'post',
    data
  });
  // 删除备件
export const addPatrs = (data:any) =>
  request({
    url: 'Order/Parts',
    method: 'post',
    data
  });
// 添加品牌
export const addProduct = (data:any) =>
  request({
    url: 'Order/Product',
    method: 'post',
    data
  });
// 删除品牌
export const deleteProduct = (data:any) =>
  request({
    url: 'Order/Product',
    method: 'delete',
    data
  });
// 删除备件
export const deleteParts = (data:any) =>
  request({
    url: 'Order/Parts',
    method: 'delete',
    data
  });

export const deleteImage = (data:any) =>
  request({
    url: 'Order/Image',
    method: 'delete',
    data
  });

export const addImage = (data:any) =>
  request({
    url: 'Order/Image',
    method: 'post',
    data
  });

export const deleteVideo = (data:any) =>
  request({
    url: 'Order/video',
    method: 'delete',
    data
  });

export const addVideo = (data:any) =>
  request({
    url: 'Order/video',
    method: 'post',
    data
  });
export const addWord = (data:any) =>
  request({
    url: 'Order/document',
    method: 'post',
    data
  });
export const deleteWord = (data:any) =>
  request({
    url: 'Order/document',
    method: 'delete',
    data
  });

export const addPrice = (data:any) =>
  request({
    url: 'Order/Price',
    method: 'post',
    data
  });

export const deletePrice = (data:any) =>
  request({
    url: 'Order/Price',
    method: 'delete',
    data
  });

export const addFault = (data:any) =>
  request({
    url: 'Order/Fault',
    method: 'post',
    data
  });

export const deleteFault = (data:any) =>
  request({
    url: 'Order/Fault',
    method: 'delete',
    data
  });

export const addRemark = (data:any) =>
  request({
    url: 'Order/Remark',
    method: 'post',
    data
  });

export const deleteRemark = (data:any) =>
  request({
    url: 'Order/Remark',
    method: 'delete',
    data
  });

// 添加、删除标签
export const handleTags = (data:any) =>
  request({
    url: 'Order/tags',
    method: 'post',
    data
  });

export const deleteTags = (data:any) =>
  request({
    url: 'Order/tags',
    method: 'delete',
    data
  });

// 添加设备
export const addDevice = (data:any) =>
  request({
    url: 'Order/device',
    method: 'post',
    data
  });

// 删除设备
export const deleteDevice = (data:any) =>
  request({
    url: 'Order/device',
    method: 'delete',
    data
  });
  // Order/checkOrderRefuseAcceptComplete
export const checkOrderRefuseAcceptComplete = (params: any) =>
  request({
    url: 'Order/checkOrderRefuseAcceptComplete',
    method: 'get',
    params
  });
export const orderRefuseAcceptComplete = (data:any) =>
  request({
    url: 'Order/orderRefuseAcceptComplete',
    method: 'post',
    data
  });
// 导入订单
export const importNOrder = (params: any) =>
  request({
    url: 'Order/importOrder',
    method: 'post',
    params
  });
